import { render, staticRenderFns } from "./XwImg.vue?vue&type=template&id=7cffd371&scoped=true"
import script from "./XwImg.vue?vue&type=script&lang=js"
export * from "./XwImg.vue?vue&type=script&lang=js"
import style0 from "./XwImg.vue?vue&type=style&index=0&id=7cffd371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffd371",
  null
  
)

export default component.exports